import Utils from '../../modules/utils'

const updateBestSellers = (cadId, deleteItems, addItems, callbackFunc) => {
  const url = 'best_sellers'
  const data = {cadId, deleteIds: deleteItems.map(item => item.id), addItems}
  Utils.post(url, data, callbackFunc)
}

export {updateBestSellers}
